module.exports = __webpack_public_path__ + "img/hero.8d4fdfcf.jpg";